import { useActiveWorkspace } from '@/true-fsd/data/advertiser-account/hooks'
import { VkOrdApiKeyResponse } from '@synapex/shared2/gateway-rest-api'
import { PickNonNullable } from '@synapex/tools/typescript'
import { useMemo } from 'react'

type Missing = {
    folderUrl?: boolean
    vkOrdApiKey?: boolean
    adOrdContragentId?: boolean
    adOrdAgencyId?: boolean
}
type AvailableData = Pick<VkOrdApiKeyResponse, 'lastKktu'> &
    PickNonNullable<
        VkOrdApiKeyResponse,
        | 'adOrdContragentId'
        | 'vkOrdApiKey'
        | 'adOrdAgencyId'
        | 'currentLinkType'
    >

export type OrdAdditionalDataAvailable = { status: 'available' } & AvailableData

export type MarkingStatus =
    | OrdAdditionalDataAvailable
    | {
          status: 'not_available'
          missing: Missing
      }

export const useMarkingStatus = (): MarkingStatus => {
    const {
        // activeAwd,
        ordData: { googleDriveConnection, ordAdditionalData },
    } = useActiveWorkspace()

    const folderUrl = googleDriveConnection?.folderUrl ?? null
    const vkOrdApiKey = ordAdditionalData?.vkOrdApiKey ?? null
    const adOrdContragentId = ordAdditionalData?.adOrdContragentId ?? null
    const lastKktu = ordAdditionalData?.lastKktu ?? null
    const currentLinkType = ordAdditionalData?.currentLinkType ?? null
    const adOrdAgencyId =
        currentLinkType === 'agency'
            ? (ordAdditionalData?.adOrdAgencyId ?? null)
            : Number(true)

    return useMemo(() => {
        if (
            folderUrl &&
            vkOrdApiKey &&
            adOrdContragentId &&
            adOrdAgencyId &&
            currentLinkType
        ) {
            return {
                status: 'available',
                vkOrdApiKey,
                adOrdContragentId,
                lastKktu,
                adOrdAgencyId,
                currentLinkType,
            }
        }

        const missing: Missing = {}

        if (!folderUrl) {
            missing.folderUrl = true
        }

        if (!vkOrdApiKey) {
            missing.vkOrdApiKey = true
        }

        if (!adOrdContragentId) {
            missing.adOrdContragentId = true
        }

        if (!adOrdAgencyId) {
            missing.adOrdAgencyId = true
        }

        return {
            status: 'not_available',
            missing,
        }
    }, [
        folderUrl,
        vkOrdApiKey,
        adOrdContragentId,
        lastKktu,
        adOrdAgencyId,
        currentLinkType,
    ])
}
